/**
 * Salvataggio dei Task commerciali creati dai suggerimenti AI della chat.
 * La logica pura (righe da inserire, scadenza) sta in salesTaskFromSuggestion.ts.
 */
import { supabase } from '@/lib/supabase';
import { buildSalesTaskInsert, type SalesTaskInput, type SalesTaskSource } from './salesTaskFromSuggestion';

/**
 * Inserisce i Task commerciali e segna come gestiti i suggerimenti WhatsApp da
 * cui nascono. Una sorgente senza id (Instagram/Messenger) crea solo il Task.
 */
export async function createSalesTasks(
  items: Array<{ request: SalesTaskSource; input: SalesTaskInput }>,
): Promise<{ created: number; errors: string[]; doneRequestIds: string[] }> {
  const errors: string[] = [];
  const doneRequestIds: string[] = [];
  let created = 0;
  for (const { request, input } of items) {
    try {
      const row = buildSalesTaskInsert(input);
      const { error } = await supabase.from('sales_activities').insert(row);
      if (error) throw error;
      created++;
      if (!request.id) continue;
      doneRequestIds.push(request.id);
      // created_task_id punta a tasks (progetti): qui si segna solo lo stato.
      await supabase
        .from('whatsapp_agent_requests')
        .update({ status: 'task_created', reviewed_by: input.userId, reviewed_at: new Date().toISOString(), updated_at: new Date().toISOString() })
        .eq('id', request.id);
      // Evento workflow 'lead:activity_created' NON emesso di proposito: la chiamata
      // esistente nel pannello usa una firma sbagliata e quindi oggi non parte mai;
      // accenderlo qui farebbe scattare automazioni finora mai attive (da decidere).
    } catch (e: any) {
      errors.push(`${request.title}: ${e?.message || 'errore sconosciuto'}`);
    }
  }
  return { created, errors, doneRequestIds };
}
